import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReplenishmentPage } from './replenishment';
import {TranslateModule} from "@ngx-translate/core";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    ReplenishmentPage,
  ],
  imports: [
    InfiniteScrollModule,
    HeaderTitleComponentModule,
    IonicPageModule.forChild(ReplenishmentPage),
    TranslateModule.forChild()
  ],
})
export class ReplenishmentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/replenishment/replenishment.module.ts